/*
 * Drop a trailing Halloween / Helloween from collection cards, the product page, and the cart.
 * Matches "Title (Halloween)" and "Title Halloween". The Shopify title is left unchanged.
 */
(function () {
  var COLLECTION_SELECTOR = '.product-grid-item__title';
  var CART_SELECTOR = '.cart__item__title';
  var PRODUCT_SELECTOR = '.product__title, .pr_title, .breadcrumbs__current';
  var TRAILING_WORD = /\s*(?:[-–—|:]\s*)?(?:\(\s*)?(?:helloween|halloween)\s*\)?\s*$/i;
  var TITLE_WORD = /\s*(?:\(\s*)?(?:helloween|halloween)\s*\)?(?=\s*[–—-]|$)/i;

  function cleanText(value) {
    if (!value || !TRAILING_WORD.test(value)) return value;
    return value.replace(TRAILING_WORD, '').trim();
  }

  function cleanElement(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var cleaned = cleanText(node.nodeValue);
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }

    if (!el.hasAttribute('aria-label')) return;
    var label = el.getAttribute('aria-label');
    var cleanedLabel = cleanText(label);
    if (cleanedLabel !== label) el.setAttribute('aria-label', cleanedLabel);
  }

  function cleanDocumentTitle() {
    var cleaned = document.title.replace(TITLE_WORD, '');
    if (cleaned && cleaned !== document.title) document.title = cleaned;
  }

  function run() {
    if (!document.body) return;
    document.querySelectorAll(CART_SELECTOR).forEach(cleanElement);
    if (document.body.classList.contains('template-collection')) {
      document.querySelectorAll(COLLECTION_SELECTOR).forEach(cleanElement);
    }
    if (document.body.classList.contains('template-product')) {
      document.querySelectorAll(PRODUCT_SELECTOR).forEach(cleanElement);
      cleanDocumentTitle();
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  function observe() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);

  document.addEventListener('shopify:section:load', schedule);
})();
